import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Microsoft365GroupSearchResult } from '../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class TeamsCallQueue365GroupResource {
  private http = inject(HttpClient);

  search(tenantId: string, query: string): Observable<Microsoft365GroupSearchResult[]> {
    return this.http.get<Microsoft365GroupSearchResult[]>(
      `/services/microsoft/call-queue-management/tenants/${tenantId}/365-groups/search?q=${encodeURIComponent(query)}`,
    );
  }
}
